import {useEffect} from "preact/hooks";

export default function useOnMount(callback: React.EffectCallback) {
  useEffect(callback, []);
}
